/* sugar:assets/drawer-menu.js@2.0.0 */
/*
 * Drawer Menu, Slide in submenus. The drawer's own script (MenuDrawer in global.js) opens a
 * top-level parent's panel, moves focus to its back arrow and closes it again from that arrow;
 * the stylesheet draws the slide. This adds the two things the drawer doesn't do: Escape inside a
 * panel closes the whole drawer instead of only the panel, and a panel opens with its first group
 * expanded when none of them is. Delegated listeners serve every Slide in menu, including ones the
 * theme editor renders later.
 */
(function () {
  if (window.__sugarDrawerMenu) return;
  window.__sugarDrawerMenu = true;

  var PARENT = '.mobile-menu-block--slide > .mobile-menu-block__list > li > details';

  // Capture phase, so this runs before the drawer's own Escape handler, which would close only the panel
  document.addEventListener(
    'keyup',
    function (event) {
      if (!event.code || event.code.toUpperCase() !== 'ESCAPE') return;
      var parent = event.target && event.target.closest && event.target.closest(PARENT + '[open]');
      if (!parent) return;
      var drawer = parent.closest('details.menu-drawer-container');
      var toggle = drawer && drawer.querySelector(':scope > summary');
      if (!toggle) return;
      event.stopPropagation();
      toggle.click();
      toggle.setAttribute('aria-expanded', 'false');
    },
    true
  );

  // toggle doesn't bubble, but a capturing listener on the document still sees it
  document.addEventListener(
    'toggle',
    function (event) {
      var parent = event.target;
      if (!parent || !parent.open || !parent.matches || !parent.matches(PARENT)) return;
      var groups = parent.querySelectorAll(
        ':scope > .mobile-menu-block__submenu-wrap > .mobile-menu-block__sublist > li > details'
      );
      if (!groups.length) return;
      for (var i = 0; i < groups.length; i++) {
        if (groups[i].open) return;
      }
      groups[0].open = true;
    },
    true
  );
})();
